<template>
  <v-list
    two-line
    class="profile-list"
  >
    <template v-for="(item, index) in items">
      <v-list-item :key="item.id">
        <v-list-item-avatar>
          <v-icon
            v-if="item.sex === 'male'"
            large
          >{{ mdiFaceManProfile }}
          </v-icon>
          <v-icon
            v-else
            large
          >{{ mdiFaceWomanProfile }}
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ item.name || 'Без имени' }}</v-list-item-title>
          <v-list-item-subtitle>
            {{ itemInfo(item) }}
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          <v-row>
            <v-btn
              class="ma-1"
              color="primary"
              :disabled="disabled"
              @click="selectProfile(item)"
            >Выбрать
            </v-btn>

            <v-btn
              class="ma-1"
              icon
              @click="editProfile(item)"
            >
              <v-icon>{{ mdiPencil }}</v-icon>
            </v-btn>

            <v-btn
              class="ma-1"
              icon
              @click="deleteProfile(item)"
            >
              <v-icon>{{ mdiTrashCan }}</v-icon>
            </v-btn>
          </v-row>
        </v-list-item-action>
      </v-list-item>

      <v-divider
        v-if="index < items.length - 1"
        :key="index"
      ></v-divider>
    </template>
  </v-list>
</template>

<script>
import {
  mdiPlus,
  mdiCalendar,
  mdiGenderMaleFemale,
  mdiAccountChild,
  mdiFaceManProfile,
  mdiFaceWomanProfile,
  mdiTrashCan,
  mdiHumanCane,
  mdiPencil
} from '@mdi/js'
import profileDB from '~/app/profile'
import registryDB from '~/app/registry'
import utils from '@/app/utils'

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mdiPlus,
      mdiCalendar,
      mdiAccountChild,
      mdiGenderMaleFemale,
      mdiFaceManProfile,
      mdiFaceWomanProfile,
      mdiTrashCan,
      mdiHumanCane,
      mdiPencil
    }
  },
  methods: {
    editProfile (profile) {
      this.$emit('edit', profile)
    },
    selectProfile (profile) {
      registryDB.set(registryDB.ACTIVE, profile.id).then(() => {
        this.$store.commit('SET_PROFILE', profile)
        this.$router.push({ name: 'home' })
      })
    },
    deleteProfile (profile) {
      if (confirm(
        'Вы действительно хотите удалить профиль ' +
        (profile.name || 'Без имени') +
        (profile.birthdate ? ' (' + profile.birthdate + ')' : '')
      )) {
        profileDB.remove(profile.id).then(() => {
          for (let i in this.items) {
            if (this.items[i].id === profile.id) {
              this.items.splice(parseInt(i), 1)
              break
            }
          }
        })
      }
    },
    itemInfo (item) {
      return profileDB.levelName(item.disability, false) +
      ', ' +
      utils.getDateDmy(new Date(item.birthdate))
    }
  }
}
</script>

<style lang="stylus" type="text/stylus">
  @media screen and (max-width: 450px)
    .profile-list
      .v-list-item__action
        flex-basis min-content
</style>
